import { Button, Input } from 'antd';
import React, { useState } from 'react';
import { EditOutlined, CheckOutlined } from '@ant-design/icons';
import classes from './style/DepartmentsCard.module.css';
interface EditTitleInputProps {
  id: number | null;
  category_id: number;
  showInput: boolean;
  handleChangeText: (value: string) => void;
  handleClick: (id: number | null, title: string, category_id: number) => void;
  text: string;
  showEditInputSwitch: () => void;
}
const EditTitleInput = (props: EditTitleInputProps) => {
  const { id, category_id, showInput, handleChangeText, handleClick, text, showEditInputSwitch } =
    props;
  const [textInput, setTextInput] = useState(text);
  const sendRequest = () => {
    handleChangeText(textInput);
    if (id !== null) {
      handleClick(id, textInput, category_id);
    } else {
      handleClick(null, textInput, category_id);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextInput(e.target.value);
  };
  if (showInput || text.length === 0) {
    return (
      <>
        <Input onChange={handleChange} onPressEnter={sendRequest} value={textInput} />
        <Button onClick={sendRequest}>
          <CheckOutlined style={{ color: 'blue' }} />
        </Button>
      </>
    );
  }
  return (
    <>
      <div>{text}</div>
      <div className={classes.titleHover}>
        <Button style={{ border: 'none', background: 'none' }} onClick={showEditInputSwitch}>
          <EditOutlined style={{ color: 'black' }} />
        </Button>
      </div>
    </>
  );
};

export default EditTitleInput;
